import { FieldPolicy } from '@apollo/client';
import { isArray } from 'lodash';

type LinkMetadataRef = {
  __ref: string;
};
export const linksMetadataMergePolicy = (): FieldPolicy<undefined | LinkMetadataRef[], LinkMetadataRef[]> => ({
  keyArgs: false,
  read(existing, options) {
    const { args, readField } = options;
    if (!existing || !args || !args.hasOwnProperty('urls')) return undefined;
    const { urls } = args;
    if (isArray(urls)) {
      const filtered = existing.filter(cachedData => {
        const fieldValue = readField('initialUrl', cachedData);
        if (typeof fieldValue !== 'string') return false;
        return urls.includes(fieldValue);
      });
      return filtered.length === urls.length ? filtered : undefined;
    } else if (typeof urls === 'string') {
      const found = existing.find(cachedData => {
        const fieldData = readField('initialUrl', cachedData);
        return urls === fieldData;
      });
      return found ? [found] : undefined;
    }
    return undefined;
  },
  merge(existing, incoming, { readField }) {
    if (!existing) return incoming;
    const filteredIncomming = incoming.filter(
      incomingItem =>
        !existing.map(item => readField('initialUrl', item)).includes(readField('initialUrl', incomingItem))
    );
    return [...existing, ...filteredIncomming];
  }
});
